<form class="text-start">
  <div
    class="row"
    *ngFor="let item of controlsData; let i = index; let last = last"
  >
    <div class="col-sm-12">
      <p
        *ngIf="item.label && isQuePage"         
        class="col-sm-12 question-label d-flex flex-wrap align-items-start"
      >
        <span class="question-number me-2">{{ i + 1 }}.</span>
        <span
          class="question-text dynamic-content title summary-heading"
          [innerHtml]="item.label"
        ></span>
      </p>
      <p *ngIf="item.label && !isQuePage" class="col-sm-12" >
        <span class="col-form-label title summary-heading" [innerHtml]="item.label"></span>
      </p>
    </div>
    <div class="col-sm-12" [ngClass]="customClass">

      <p *ngIf="item.type === 'select'">
        <span *ngFor="let option of item.options">
          <span *ngIf="option.value == item.value" class="font-normal">
          {{ option.key }}
          </span>
        </span>
      </p>
      <p *ngIf="item.type !== 'select' && item.type !== 'hidden'" class="font-normal">
        {{item.value}}
      </p>

      <hr *ngIf="item.type !== 'hidden'"/>
    </div>
  </div>
</form>
